import { render } from "./EmptyTable.vue?vue&type=template&id=83f8bfaa&ts=true"
import script from "./EmptyTable.vue?vue&type=script&lang=ts"
export * from "./EmptyTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__